import React from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { getTextFromHtml } from 'utils/transform';
import { formatDateTime } from 'utils/format';
import { routes } from 'utils/routing';
import FaceBookIcon from 'components/svg/24px-icon-facebook.svg';
import MessengerIcon from 'components/svg/24px-icon-messenger.svg';
import WhatsAppIcon from 'components/svg/24px-icon-whatsapp.svg';
import TwitterIcon from 'components/svg/24px-icon-x.svg';
import EmailIcon from 'components/svg/24px-icon-email.svg';

export const getEventUrl = (eventId) => {
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    const { link } = routes.event(eventId);
    return `${protocol}//${hostname}${link}`;
  }
};

const socialData = [
  {
    id: 1,
    type: 'SMS',
    icon: <ChatBubbleOutlineIcon color="inherit" />,
    isMobile: true,
    isDesktop: false,
    share: (t, event) => {
      const url = getEventUrl(event.id);

      const textContent = t('event.shareMenu.text', {
        event: event.title,
        host: event.organization.title,
        date: formatDateTime(event.start_at, event.timezone),
      });
      return `sms:?&body=${textContent}. ${url}`;
    },
  },
  {
    id: 2,
    type: 'Facebook',
    icon: <FaceBookIcon />,
    isMobile: true,
    isDesktop: true,
    share: (t, event) => {
      const url = getEventUrl(event.id);
      window.FB.ui({ method: 'share', href: url }, (response) => {
        if (response && response.error_message) {
          console.log(response.error_message);
        }
      });
    },
  },
  {
    id: 3,
    type: 'Messenger',
    icon: <MessengerIcon />,
    isMobile: false,
    isDesktop: true,
    share: (t, event) => {
      const url = getEventUrl(event.id);
      window.FB.ui({ method: 'send', link: url }, () => {});
    },
  },
  {
    id: 4,
    type: 'Whatsapp',
    icon: <WhatsAppIcon color="inherit" />,
    isMobile: true,
    isDesktop: true,
    share: (t, event) => {
      const url = getEventUrl(event.id);
      const target = new URL('/send', 'https://api.whatsapp.com');
      target.searchParams.append('text', url);
      window.open(target.toString());
    },
  },
  {
    id: 5,
    type: 'Twitter',
    icon: <TwitterIcon color="inherit" />,
    isMobile: true,
    isDesktop: true,
    share: (t, event) => {
      const target = new URL('/intent/tweet', 'https://twitter.com');
      const url = getEventUrl(event.id);
      const textContent = t('event.shareMenu.text', {
        event: event.title,
        host: event.organization.title,
        date: formatDateTime(event.start_at, event.timezone),
      });

      target.searchParams.append('text', textContent);
      target.searchParams.append('url', url);
      window.open(target.toString());
    },
  },
  {
    id: 6,
    type: 'Email',
    icon: <EmailIcon color="inherit" />,
    isMobile: true,
    isDesktop: true,
    share: (t, event) => {
      const nextLine = '%0D%0A';
      const url = getEventUrl(event.id);

      const emailSubject = t('event.shareMenu.email.subject', {
        event: event.title,
        host: event.organization.title,
      });

      const emailBodyHead = t('event.shareMenu.email.body.checkOut', {
        event: event.title,
      });

      const emailBodyHost = t('event.shareMenu.email.body.by', {
        host: event.organization.title,
      });

      const emailBodyDate = formatDateTime(event.start_at, event.timezone);

      const emailBodyEventDescription = getTextFromHtml(event.description);

      window.location.href = `mailto:?&subject=${emailSubject}&body=${emailBodyHead}${nextLine}${emailBodyHost}
      ${nextLine}${emailBodyDate}.${nextLine}${url}.${nextLine}${nextLine}${emailBodyEventDescription}`;
    },
  },
];

export default socialData;
